module.exports = __webpack_public_path__ + "static/media/trailers.77060669.svg";